<nz-radio-group (ngModelChange)="notify($event)" [(ngModel)]="mediaType">
  <label [nzValue]="'AUDIO'" nz-radio>Audio</label>
  <label [nzValue]="'IMAGE'" nz-radio>Image</label>
  <label [nzValue]="'HOSTED_VIDEO'" nz-radio>Video</label>
</nz-radio-group>
